// ==============================|| OVERRIDES - TABLE ROW ||============================== //

export default function TableRow(theme) {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: theme.vars.palette.action.hover
          },
          '&:last-of-type': {
            '& .MuiTableCell-root': {
              borderBottom: 'none'
            }
          }
        }
      }
    }
  };
}
